var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "account-cards__item" }, [
    _vm.type
      ? _c("div", [
          _c("div", { staticClass: "account__heading" }, [
            _vm._v(" " + _vm._s(_vm.$t(`account.lms${_vm.type}.title`)) + " ")
          ]),
          _c("div", { staticClass: "account-block" }, [
            _c("span", { staticClass: "account__subtitle" }, [
              _vm._v(
                _vm._s(_vm.$t(`account.lms${_vm.type}.available${_vm.type}`))
              )
            ]),
            _c("span", { staticClass: "account__text" }, [
              _vm._v(_vm._s(_vm.formatSubscription()))
            ])
          ]),
          _c("div", { staticClass: "account-block" }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expirationDate,
                    expression: "expirationDate"
                  }
                ],
                staticClass: "account__subtitle"
              },
              [
                _vm._v(
                  _vm._s(_vm.$t(`account.lms${_vm.type}.expirate${_vm.type}`))
                )
              ]
            ),
            _vm.expirationDate
              ? _c("span", { staticClass: "account__text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t(`account.lmsCredits.endDateLabel`)) +
                      " " +
                      _vm._s(_vm.dateFormat())
                  )
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "account__link" },
            [
              _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "profile-guard",
                      rawName: "v-profile-guard",
                      value: `components.plan.credits.edit.seeRecords`,
                      expression: "`components.plan.credits.edit.seeRecords`"
                    }
                  ],
                  attrs: { to: { name: "client-credits-record" }, exact: "" }
                },
                [_vm._v(" " + _vm._s(_vm.$t(`actions.seeRecord`)))]
              ),
              _vm.type === "Credits"
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "profile-guard",
                          rawName: "v-profile-guard",
                          value: `components.plan.credits.edit.manageCredits`,
                          expression:
                            "`components.plan.credits.edit.manageCredits`"
                        }
                      ],
                      attrs: { to: { name: "credits-record" }, exact: "" }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t(`actions.manageCredits`)))]
                  )
                : _vm._e(),
              _vm.type === "Credits"
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "profile-guard",
                          rawName: "v-profile-guard",
                          value: `components.plan.credits.edit.buyCredits`,
                          expression:
                            "`components.plan.credits.edit.buyCredits`"
                        }
                      ],
                      attrs: { to: { name: "buy-credits" }, exact: "" }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t(`actions.buy${_vm.type}`)))]
                  )
                : _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "profile-guard",
                          rawName: "v-profile-guard",
                          value: `components.plan.subscription.edit.manageSubscription`,
                          expression:
                            "`components.plan.subscription.edit.manageSubscription`"
                        }
                      ],
                      attrs: { to: { name: "subscription-record" }, exact: "" }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t(`actions.manageSubscription`)))]
                  )
            ],
            1
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "account__heading" }, [
            _vm._v(" " + _vm._s(_vm.$t("account.lmsUsers.title")) + " ")
          ]),
          _c("div", { staticClass: "account-block" }, [
            _c("span", { staticClass: "account__text" }, [
              _vm._v(_vm._s(_vm.$t("account.lmsUsers.notAvailable")))
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }